import { Util, Bridge, Platform } from "@xt/xtbase";
import { toLoginBase, toRegisterBase } from './method';
import { getThirdPartyBuyUrl } from "./openThirdPartyBuy";

/**
 * 
 * @param json 
 * const json = {
  * type: '', //类型
  *  params: {}, //参数 
  *}
 */
export const nativecall = (json) => {
  const jsonString = JSON.stringify(json);

  try {
    if (Platform.isIOS()) {
      window.webkit.messageHandlers.xt_h5.postMessage(jsonString);
    } else {
      window.android.xt_h5(jsonString);
    }
  } catch {
    window.open(json.params.url, '_blank');
  }
};

export const openUrlInNewWindow = (url) => {
  if (Platform.isInApp()) {
    nativecall({
      type: 'browserOpen',
      params: {
        url: encodeURI(url),
      },
    });
  } else {
    window.open(encodeURI(url));
  }
};

export const toLogin = () => {
  if (Platform.isInApp()) {
      Bridge.routeTo("/account/login");
  } else {
    toLoginBase();
  }
};

export const toRegister = () => {
  if (Platform.isInApp()) {
      Bridge.routeTo("/account/register");
  } else {
    toRegisterBase();
  }
};

const { compareVersion } = Util;

const origin = Util.getOrigin("www");

// 去充值
export const toDeposit = (currency = "USDT") => {
  if (Platform.isInApp()) {
    Bridge.routeTo("/deposit", { currency: String(currency).toUpperCase() });
  } else {
    const normalizedCurrency = String(currency || "usdt").toLowerCase();
    window.location.href = `${origin}/wallet/account/common/deposit?currency=${encodeURIComponent(normalizedCurrency)}`;
  }
};

// 去交易
export const toFutureTrade = (lang, market = 'btc_usdt') => {
  if (Platform.isInApp()) {
    Bridge.routeTo('/futures/usd-m', {
      market,
    });
  } else {
    window.location.href = `${origin}/${lang}/futures/trade/${market}`;
  }
};

// 去现货交易
export const toSpotTrade = (lang, market = 'btc_usdt') => {
  if (Platform.isInApp()) {
    Bridge.routeTo('/trade/spot', {
      market,
    });
  } else {
    window.location.href = `${origin}/${lang}/trade/${market}`;
  }
};

// 去资产总览
export const toAssets = () => {
  if (Platform.isInApp() && compareVersion(Bridge.getVersion(),"4.0.0") >= 0 ) {
    Bridge.routeTo('/finance');
  } else {
    window.location.href = `${origin}/wallet/account/overview`;
  }
};

// 去福利中心卡券
export const toCardCoupon = (lang) => {
  if (Platform.isInApp() && compareVersion(Bridge.getVersion(),"4.22.0") >= 0 ) {
    Bridge.routeTo('/welfare-center', {index: 1});
  } else {
    window.location.href = `${origin}/${lang}/activity/coupon?page=weal&status=1`;
  }
};

// 实名认证
export const toVerification = (lang) => {
  if (Platform.isInApp()) {
    Bridge.routeTo('/personal-verification');
  } else {
    window.location.href = `${origin}/account/personal`;
  }
};

// 邀请返佣
export const toReferral = (lang) => {
  if (Platform.isInApp()) {
    Bridge.routeTo('/referral');
  } else {
    window.location.href = `${origin}/${lang}/referral`;
  }
}

// p2p — /otc/index 已下线
export const toP2p = () => {
  if (Platform.isInApp()) {
    Bridge.routeTo('/quick-buy/p2p-trading');
  }
  // else {
  //   window.location.href = `${origin}/otc/index`;
  // }
}

export const toDebitCard = () => {
  if (Platform.isInApp()) {
    Bridge.routeTo('/quick-buy/third-party-payment');
  } else {
    window.location.href = getThirdPartyBuyUrl();
  }
};

// 现货账户
export const toSpotAccount = () => {
  if (Platform.isInApp() && compareVersion(Bridge.getVersion(),"4.0.0") >= 0) {
    Bridge.routeTo('/finance', {
      index: 'spot',
    });
  } else {
    window.location.href = `${origin}/wallet/account/spot`;
  }
}

// 理财主页（/finance/* 已下线）
export const toFinanceIndex = () => {
  if (Platform.isInApp()) {
    Bridge.routeTo('/saving');
  } else {
    window.location.href = `${origin}/`;
  }
}
